export const Roles = {
  USER: "USER",
  ADMIN: "ADMIN",
  SUPERADMIN: "SUPERADMIN",
} as const;

export type RoleName = (typeof Roles)[keyof typeof Roles];

/** i18n key mapping for role display names */
export const ROLE_I18N_KEYS: Record<RoleName, string> = {
  [Roles.USER]: "users.role.USER",
  [Roles.ADMIN]: "users.role.ADMIN",
  [Roles.SUPERADMIN]: "users.role.SUPERADMIN",
};

/** Roles shown in the create/edit user role picker */
export const ASSIGNABLE_ROLES: RoleName[] = [Roles.USER, Roles.ADMIN];

/** Roles that can access admin pages (users, activity history) */
export const ADMIN_PAGE_ROLES: RoleName[] = [Roles.ADMIN, Roles.SUPERADMIN];

/** Default role for new admin-created users */
export const DEFAULT_NEW_USER_ROLE: RoleName = Roles.USER;
